/*
* 车辆维修管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Select,
    Button,
    Statistic,
    Input,
    Tag,
    Space,
    theme,
} from 'antd';
import { PlusOutlined, ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    GetButtonActionName
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import CarRepairEntity from './CarRepairEntity.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[1].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[1].ptn;

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
        },
    } = theme.useToken();

    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'car/repairs/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '车牌号码', dataIndex: 'license_number', key: 'license_number', fixed: 'left', width: 120, },
        { title: '维修类型', dataIndex: 'type', key: 'type', },
        { title: '维修明细', dataIndex: 'detail', key: 'detail', },
        { title: '修理厂家', dataIndex: 'repair_factory', key: 'repair_factory', },
        {
            title: '维修费用(元)', key: 'amount',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '40%' : '60%' }} color={colorPrimaryBg}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.amount} /></Tag>
        },
        { title: '维修时间', dataIndex: 'time', key: 'time', },
        { title: '申请人', dataIndex: 'apply_displayname', key: 'apply_displayname', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        总计：<Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={props.sumAmount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={props.sumAmount > 10000 ? props.sumAmount / 10000 : props.sumAmount} /></Tag>
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            sumAmount: 0,
            carUlid: '',
            type: '',
            carLists: [],
            repairFactory: '',

        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeLicenseNumber = (value) => { this.setState({ carUlid: value === undefined ? '' : value }); this.search(); }
    changeType = (value) => { this.setState({ type: value === undefined ? '' : value }); this.search(); }
    changeRepairFactory = (e) => { this.setState({ repairFactory: e.target.value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }
    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'car_ulid': this.state.carUlid,
            'type': this.state.type,
            'repair_factory': this.state.repairFactory,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}car/repairs${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt,
                            sumAmount: data.qss.amount,
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0,
                            sumAmount: 0,
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出 Excel
    */
    exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆维修明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆维修明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '维修类型',
                    '维修明细',
                    '修理厂家',
                    '维修费用',
                    '维修时间',
                    '故障原因',
                    '故障描述',
                    '申请人'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出车辆信息明细
     */
    export() {
        const _this = this;
        const params = {
            'car_ulid': this.state.carUlid,
            'type': this.state.type,
            'repair_factory': this.state.repairFactory,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}car/maintenances${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['car_ulid'];
                            // delete item['status'];
                            delete item['apply_username']
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            d.push(item);
                        }
                        _this.exportAsExcel(d);
                    } else {
                        _this.exportAsExcel([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
     * 获取车辆下拉列表
     */
    carDDList = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': CNF.pageSize * 100,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}cars${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.setState({ carLists: data.dat });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.carDDList();
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Select
                            showSearch
                            allowClear
                            style={{ width: '100%' }}
                            placeholder='请选择车辆'
                            onChange={this.changeLicenseNumber}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            {
                                this.state.carLists && this.state.carLists.map((item) => {
                                    return <Option key={item.key} value={item.key}>{item.license_number}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: 5 }}>
                        <Select
                            allowClear
                            style={{ width: '100%' }}
                            placeholder='维修类型'
                            onChange={this.changeType}>
                            {
                                CNF.repairTypes && CNF.repairTypes.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: 5 }}>
                        <Input
                            onChange={this.changeRepairFactory}
                            placeholder='修理厂家...'
                            value={this.state.repairFactory}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <CarRepairEntity
                        policy={this.props.policy}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                        carLists={this.state.carLists}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            sumAmount={this.state.sumAmount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT